export default "__VITE_ASSET__C$gb2xcj__"